import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindGa, gaWrapper } from 'helpers/analytics';
import VideoLoader from 'components/Video/VideoLoader';
// import { setPlayerHeadless } from 'components/Video/utils';
import Image from 'components/Image';
import {
  inViewForReact,
  getCustomClassesForPayload,
  isTablet,
} from 'utils/common';
import InViewObserver from 'components/InViewObserver/InViewObserver';
import ImageV2 from 'components_v2/common/ImageV2';
import {
  addDockCandidate,
  addUnDockCandidate,
  deleteDockCandidate,
  deleteUnDockCandidate,
} from 'routes/articleshow_v2/redux';

//import { iframeYoutubeHeight } from './config';

function getMsidArrayFromVideolisting(videoListdata) {
  if (videoListdata instanceof Array) {
    return videoListdata.map(item => item.id);
  }
  return [];
}
class VideoWidget extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      userPlay: false,
      elemInView: false,
      dockTimerCountdown: null,
    };
    this.state.videoActive = props.videoActive;
    this.videoRef = React.createRef();
    this.handleVideoImageComponentClick = this.handleVideoImageComponentClick.bind(
      this,
    );
    this.handleVideoComponentClick = this.handleVideoComponentClick.bind(this);
    this.dockTimerCompleted = false;
  }

  pausePlayer = () => {
    if (window && window.player && window.player.length > 0) {
      window.player.forEach((item, index) => {
        if (item.store.clientConfig.contEl === this.props.playerContainerId)
          window.player[index].pause();
      });
    }
  };

  mWebDeleteDoc = () => {
    if (
      typeof this.props.deleteDockCandidate === 'function' &&
      this.props.dockCandidate !== 'undefined'
    ) {
      if (
        typeof window !== 'undefined' &&
        window.player &&
        window.player.length > 0
      ) {
        window.player.forEach((item, index) => {
          window.player[index].pause();
        });
      }
      this.props.deleteDockCandidate();
    }
    if (
      typeof this.props.deleteUnDockCandidate === 'function' &&
      this.props.unDockCandidate !== 'undefined'
    ) {
      this.props.deleteUnDockCandidate();
    }
  };

  webDeleteDoc = () => {
    if (
      typeof this.props.deleteDockCandidate === 'function' &&
      this.props.dockCandidate !== 'undefined'
    ) {
      if (
        typeof window !== 'undefined' &&
        window.player &&
        window.player.length > 0
      ) {
        window.player.forEach((item, index) => {
          // if (
          //   item.store.clientConfig.contEl ===
          //   this.props.dockCandidate?.containerId
          // )
          window.player[index].pause();
        });
      }
      this.props.deleteDockCandidate();
    }
    if (
      typeof this.props.deleteUnDockCandidate === 'function' &&
      this.props.unDockCandidate !== 'undefined'
    ) {
      this.props.deleteUnDockCandidate();
    }
  };

  componentDidMount = () => {
    window.addEventListener(
      'ARTICLECHANGEPERPEC',
      () => {
        this.mWebDeleteDoc();
      },
      false,
    );
    window.addEventListener(
      'ARTICLECHANGEPERPECWEB',
      () => {
        this.webDeleteDoc();
      },
      false,
    );
  };

  componentDidUpdate = () => {
    if (
      this.props.unDockCandidate &&
      this.props.video &&
      this.props.unDockCandidate.msid === this.props.video.id &&
      !this.dockTimerCompleted &&
      this.state.dockTimerCountdown !== null
    ) {
      const timer = setInterval(() => {
        this.setState(
          {
            dockTimerCountdown: this.state.dockTimerCountdown - 1,
          },
          () => {
            if (this.state.dockTimerCountdown === 0) {
              clearInterval(timer);
              if (
                this.props.unDockCandidate &&
                this.props.video &&
                this.props.unDockCandidate.msid === this.props.video.id
              ) {
                this.pausePlayer();
              }
            }
          },
        );
      }, 1000);
      this.dockTimerCompleted = true;
    }

    // if (
    //   this.props.unDockCandidate &&
    //   this.props.video &&
    //   this.props.unDockCandidate.msid === this.props.video.id
    // ) {
    //   setPlayerHeadless(true);
    // } else {
    //   setPlayerHeadless(false);
    // }
  };

  getSource(isPrime, isArticleshow) {
    let source = 'videoshow';
    if (isArticleshow) {
      source = 'articleshow';
    }
    if (this.props.isLeadVideo && !this.props.isWapView && !isPrime) {
      source = 'ABOVEARTICLE_0';
    } else if (isPrime) {
      source = 'PRIME_TOPVOD';
    }

    return source;
  }

  getYouTubeVideoComponent() {
    const { video, lazyLoadYoutubeVid } = this.props;
    let vidsrc = `https://www.youtube.com/embed/${video.playerId}`;
    if (video.runTime || video.startTime) {
      vidsrc = `https://www.youtube.com/embed/${
        video.playerId
      }?start=${video.runTime || video.startTime}`;
    }
    if ((video.runTime || video.startTime) && video.endTime) {
      vidsrc += `&end=${video.endTime}`;
    } else if (video.endTime) {
      vidsrc += `?end=${video.endTime}`;
    }

    const s = this.props.styleObj;

    if (lazyLoadYoutubeVid) {
      return (
        <InViewObserver
          viewMargin="300px 0px 300px 0px"
          className={s.content}
          inViewCallback={() => {
            this.setState({ elemInView: true });
          }}
        >
          {this.state.elemInView && (
            <iframe
              width="100%"
              //height={iframeYoutubeHeight}
              height="100%"
              frameBorder="0"
              allowFullScreen
              src={vidsrc}
              title={video.hl}
            />
          )}
        </InViewObserver>
      );
    }

    return (
      <div className={s.content}>
        <iframe
          width="100%"
          //height={iframeYoutubeHeight}
          height="100%"
          frameBorder="0"
          allowFullScreen
          src={vidsrc}
          title={video.hl}
        />
      </div>
    );
  }

  @bindGa({})
  handleVideoComponentClick() {
    this.setState({
      videoActive: false,
    });
    this.props.videoPlayCallback(false);
  }

  getVideoComponent(isAutoPlayOn) {
    const s = this.props.styleObj;
    const tthis = this;
    const {
      video,
      iconClassName,
      videoClassName,
      theatreModeClassName,
      isPrime,
      playerContainerId,
      onVideoComplete,
      unDockCandidate,
      isUserPrime,
      isLeadVideo,
      dataCloseClickGa,
      isInline,
      isWapView,
      enableDocking,
    } = this.props;
    const isDocked = unDockCandidate && unDockCandidate.msid === video.id;
    const dockClass = isWapView ? s.dockplayer_mobile : s.dockplayer;
    const dockedClassName = `${
      unDockCandidate && unDockCandidate.msid === video.id ? dockClass : ''
    }`;
    const updateplayerConfig =
      isWapView && enableDocking
        ? {
            skipReco: true,
            // gestureControls: false,
          }
        : {};
    // const isDockingEnabled =
    //   (isLeadVideo || isPrime) &&
    //   !this.props.isWapView &&
    //   !isTablet() &&
    //   !this.props.loadedMiniTvComponent;
    return (
      <>
        {!isPrime && (
          <span
            className={`${s.vdo_closeicon} vdo_closeicon`}
            onClick={this.handleVideoComponentClick}
            data-ga={dataCloseClickGa}
          />
        )}
        <VideoLoader
          isLeadVideo={isLeadVideo}
          videoRef={this.videoRef}
          autoplay={isAutoPlayOn}
          isMute={this.props.loadedMiniTvComponent ? false : this.props.isMute}
          videoClassName={videoClassName}
          msid={video.id}
          slikeId={video.playerId}
          imgsize={video.imagesize}
          playerContainerId={playerContainerId}
          iconClassName={iconClassName}
          isPrime={isPrime}
          isUserPrime={isUserPrime}
          allowDim={false}
          source={this.getSource(isPrime, this.props.isArticleshow)}
          // isDockingEnabled={isDockingEnabled}
          isDocked={isDocked}
          dockTitle={isDocked ? video.hl : ''}
          dockedClassName={dockedClassName}
          theatreModeClassName={theatreModeClassName}
          deleteDockCandidate={deleteDockCandidate}
          deleteUnDockCandidate={deleteUnDockCandidate}
          dockedPlayerMobileClass="mweb_as_dock"
          videoTheatreSliderData={this.props.videoTheatreSliderData}
          store={this.context.store}
          isVideoSkipAds={this.props.isVideoSkipAds}
          outsideEventListener={(...args) => {
            if (args[1] && args[1][1] === 'DIM_TOGGLE') {
              //
              //this.toggleDim();
            } else if (args[1] && args[1][1] === 'VIDEOCOMPLETE') {
              if (typeof onVideoComplete === 'function' && !isDocked) {
                onVideoComplete();
              }
            }
            this.videoEventListener(args[1], tthis);
          }}
          isInline={isInline}
          scrollAutoPlay={
            (!this.props.enableDocking && this.props.isWapView) ||
            this.props.loadedMiniTvComponent ||
            isTablet()
          }
          scrollAutoPause={
            (!this.props.enableDocking && this.props.isWapView) ||
            this.props.loadedMiniTvComponent ||
            isTablet()
          }
          isWapView={this.props.isWapView}
          dockTimerCountdown={this.state.dockTimerCountdown}
          sectionName={this.props.isWapView ? 'articleshow' : ''}
          updateplayerConfig={updateplayerConfig}
          videoInloop
          tmplSource='videoshow'
        />
      </>
    );
  }

  docCandiAddRemove = (tthis, dockCandidate) => {
    if (
      typeof this.props.deleteUnDockCandidate === 'function' &&
      this.props.unDockCandidate?.msid !== this.props.video.id
    ) {
      this.props.deleteUnDockCandidate();
    }
    if (
      typeof this.props.deleteDockCandidate === 'function' &&
      this.props.dockCandidate !== 'undefined' &&
      this.props.dockCandidate?.msid !== this.props.video.id
    ) {
      if (window && window.player && window.player.length > 0) {
        window.player.forEach((item, index) => {
          if (item.store.clientConfig.contEl !== this.props.playerContainerId)
            window.player[index].pause();
        });
      }
      this.props.deleteDockCandidate();
    }
    this.props.addDockCandidate({
      ref: tthis.videoRef.current,
      msid: this.props.video.id,
      containerId: this.props.playerContainerId,
      isLeadVideo: this.props.isLeadVideo,
    });
    if (
      !inViewForReact(document.getElementById(this.props.playerContainerId))
    ) {
      this.props.addUnDockCandidate(dockCandidate);
    }
  };

  @bindGa({})
  videoEventListener = (data, tthis) => {
    this.a = '';
    const videoEvent = data ? data[1] : '';
    let newMsid = '';
    let currentMsid = '';
    // let newUrl = '';
    const nextVideomsidArray = getMsidArrayFromVideolisting(
      this.props.videoTheatreSliderData,
    );
    switch (videoEvent) {
      case 'VOD_LOADED':
        if (
          (!this.props.isWapView || this.props.enableDocking) &&
          this.props.loadedMiniTvComponent &&
          !this.state.userPlay &&
          !isTablet()
        ) {
          this.setState({
            videoActive: false,
          });
          this.props.videoPlayCallback(false);
        }
        if (
          (!this.props.isWapView || this.props.enableDocking) &&
          !this.props.loadedMiniTvComponent &&
          !isTablet()
        ) {
          this.docCandiAddRemove(tthis, { ...this.props.dockCandidate });
          //this.props.addUnDockCandidate({ ...this.props.dockCandidate });
        }
        if (
          this.props.enableDocking &&
          !this.dockTimerCompleted
          //this.props.autoPlay
        ) {
          this.setState({
            dockTimerCountdown: 15,
          });
        }
        break;
      case 'PLAYING':
        if (
          (!this.props.isWapView || this.props.enableDocking) &&
          !this.props.loadedMiniTvComponent &&
          !isTablet()
        ) {
          this.docCandiAddRemove(tthis, { ...this.props.dockCandidate });
          // this.props.addUnDockCandidate({ ...this.props.dockCandidate });
        }
        break;
      case 'ADRESUME':
      case 'ADVIEW':
        if (
          (!this.props.isWapView || this.props.enableDocking) &&
          !this.props.loadedMiniTvComponent &&
          !isTablet()
        ) {
          this.docCandiAddRemove(tthis, { ...this.props.dockCandidate });
          // this.props.addUnDockCandidate({ ...this.props.dockCandidate });
        }
        break;
      case 'VIDEOINIT':
        if (!isTablet()) {
          if (!this.props.isLeadVideo && this.props.isInline) {
            // this.props.addUnDockCandidate({ ...this.props.dockCandidate });
            const gaCategory = this.props.isWapView
              ? 'VideoPlayer_MWeb_TOI'
              : 'VideoPlayer_Web_TOI';
            const gaLabel = this.props.isWapView
              ? 'Click_VideoPlayerAS_Embedd'
              : `Click_VideoPlayerAS-Embedded_P-${this.props.posKey}`;
            gaWrapper(
              'send',
              'event',
              gaCategory,
              gaLabel,
              `Articleshow_LP_${window.location.href}_VidURL_${
                this.props.video?.wu
              }`,
              {
                nonInteraction: 1,
              },
            );
          } else if (this.props.isLeadVideo) {
            const gaCategory = this.props.isWapView
              ? 'VideoPlayer_MWeb_TOI'
              : 'VideoPlayer_Web_TOI';
            const gaAction = this.props.isWapView
              ? 'View_VideoPlayerAS_Related'
              : 'View_VideoPlayerAS';
            gaWrapper(
              'send',
              'event',
              gaCategory,
              gaAction,
              `Articleshow_LP_${window.location.href}_VidURL_${
                this.props.video?.wu
              }`,
              {
                nonInteraction: 1,
              },
            );
          }
          if (!this.props.loadedMiniTvComponent) {
            this.docCandiAddRemove(tthis, { ...this.props.dockCandidate });
          }
        }
        break;
      case 'VIDEOREADY':
        newMsid = data && data.length > 2 && data[2];
        this.props.addNextVideoMsid(
          nextVideomsidArray[nextVideomsidArray.indexOf(newMsid) + 1],
        );
        break;
      case 'VIDEOCOMPLETE':
        currentMsid = data && data.length > 0 && data[0].id;
        newMsid =
          nextVideomsidArray[nextVideomsidArray.indexOf(currentMsid) + 1];
        break;
      default:
      // console.log('messageName');
    }
  };

  @bindGa({})
  handleVideoImageComponentClick() {
    this.setState({
      videoActive: true,
      userPlay: true,
    });
    this.props.videoPlayCallback(true);
  }
  videoWidgetFocus() {
    if (
      this.props.isLeadVideo &&
      this.props.activeMsid === this.props.artilceMsid &&
      !this.props.loadedMiniTvComponent
    ) {
      this.handleVideoImageComponentClick();
    }
  }
  getVideoImageComponent() {
    // const s = this.props.styleObj;
    const {
      video,
      // notitle,
      iconClassName,
      imageClassName,
      videoClassName,
      videoImageId,
      dataFirstPlayClickGa,
      dataSetGaCategory,
      isLeadVideo,
    } = this.props;
    let imgsize;
    if (video.imagesize) {
      imgsize = video.imagesize;
    } else {
      imgsize =
        video.imageid &&
        video.imageid.indexOf('&') &&
        video.imageid.split('&imgsize=')[1];
    }

    return (
      <>
        <div
          className={videoClassName}
          data-ga={dataFirstPlayClickGa}
          data-setgacategory={!!dataSetGaCategory}
          onClick={this.handleVideoImageComponentClick}
        >
          {!isLeadVideo && (
            <Image
              msid={video.id}
              src={`https://static.toiimg.com/thumb/msid-${video.id ||
                videoImageId},imgsize-${imgsize},width-400,resizemode-4/${video.id ||
                videoImageId}.jpg`}
              imgsize={video.imageid || ''}
              imageClassName={imageClassName}
              placeHolderSrc="https://static.toiimg.com/photo/42706777.gif"
              lazyload={!isLeadVideo}
              altTitle={video.hl ? video.hl : ''}
              title={video.hl ? video.hl : ''}
            />
          )}
          <i className={iconClassName} />
        </div>
        {/* {!notitle &&
          video.hl && (
            <p>
              <span className={s.duration}>{video.du}</span>
              <b>{video.hl}</b>
            </p>
        )} */}
        
        <div className="tagLabel">
          {isLeadVideo ? video.duration : video.du}
        </div>
      </>
    );
  }

  getAutoPlayVideo() {
    const s = this.props.styleObj;
    const returnHtml = this.getVideoImageComponent();
    return (
      <>
        <InViewObserver
          viewMargin="300px 0px 300px 0px"
          className={s.content}
          inViewCallback={this.videoWidgetFocus()}
        >
          {returnHtml}
        </InViewObserver>
      </>
    );
  }

  render() {
    const s = this.props.styleObj;
    const { video, loadedMiniTvComponent } = this.props;
    let { autoPlay } = this.props;
    if (loadedMiniTvComponent) {
      autoPlay = false;
    }
    let dockParentBg = '';
    // const ImageElement = ImageV2;
    let imgsize;
    if (video.imagesize) {
      imgsize = video.imagesize;
    } else {
      imgsize =
        video.imageid &&
        video.imageid.indexOf('&') &&
        video.imageid.split('&imgsize=')[1];
    }

    let returnHtml;
    if (
      this.props.video.playerType === 'youtube' &&
      !(this.props.isLeadVideo && !this.props.isWapView)
    ) {
      returnHtml = this.getYouTubeVideoComponent();
    } else if (this.state.videoActive || autoPlay) {
      const { videoImageId, unDockCandidate } = this.props;
      const isDocked = unDockCandidate && unDockCandidate.msid === video.id;
      this.props.leadVideoIsDockedCallback(isDocked);
      dockParentBg =
        isDocked && !this.props.isLeadVideo
          ? `no-repeat center/100% url(https://static.toiimg.com/photo/${videoImageId ||
              video.id}.cms)`
          : '';
      returnHtml = this.getVideoComponent(true);
    } else if (
      this.props.isLeadVideo &&
      (!this.props.isWapView || this.props.enableAutoPlay)
    ) {
      returnHtml = this.getAutoPlayVideo();
    } else {
      returnHtml = this.getVideoImageComponent();
    }
    return (
      <div
        className={`${s.img_wrapper} ${s.inlinevdo_cont} video_blk ${
          this.props.video.payload
            ? getCustomClassesForPayload(
                this.props.video.payload.toLowerCase(),
                s,
              )
            : ''
        }`}
        style={{
          background: dockParentBg,
        }}
      >
        {returnHtml}
      </div>
    );
  }
}

VideoWidget.propTypes = {
  video: PropTypes.shape({
    id: PropTypes.string.isRequired,
    hl: PropTypes.string.isRequired,
    playerType: PropTypes.string.isRequired,
    playerId: PropTypes.string.isRequired,
    imageid: PropTypes.string.isRequired,
    payload: PropTypes.string.isRequired,
  }),
  playerContainerId: PropTypes.string,
  iconClassName: PropTypes.string,
  // notitle: PropTypes.bool,
  imageClassName: PropTypes.string,
  videoClassName: PropTypes.string,
  theatreModeClassName: PropTypes.string,
  videoActive: PropTypes.bool,
  styleObj: PropTypes.shape({}).isRequired,
  isPrime: PropTypes.bool,
  videoImageId: PropTypes.string.isRequired,
  videoPlayCallback: PropTypes.func,
  //VideoComponentLoadOrUnloadListener: PropTypes.func,
  isWapView: PropTypes.bool,
  onVideoComplete: PropTypes.func,
  dockCandidate: PropTypes.shape({}),
  unDockCandidate: PropTypes.shape({}),
  addDockCandidate: PropTypes.func,
  addUnDockCandidate: PropTypes.func,
  deleteDockCandidate: PropTypes.func,
  deleteUnDockCandidate: PropTypes.func,
  isLeadVideo: PropTypes.bool,
  isUserPrime: PropTypes.bool,
  videoTheatreSliderData: PropTypes.arrayOf({}),
  addNextVideoMsid: PropTypes.func,
  // enableNextVideos: PropTypes.bool,
  dataFirstPlayClickGa: PropTypes.string,
  dataCloseClickGa: PropTypes.string,
  isArticleshow: PropTypes.bool,
  dataSetGaCategory: PropTypes.bool,
  isVideoSkipAds: PropTypes.bool,
  isInline: PropTypes.bool,
  loadedMiniTvComponent: PropTypes.bool,
  posKey: PropTypes.string,
  lazyLoadYoutubeVid: PropTypes.bool,
  isMute: PropTypes.bool,
  enableDocking: PropTypes.bool,
  leadVideoIsDockedCallback: PropTypes.func,
};

VideoWidget.defaultProps = {
  notitle: false,
  video: {},
  playerContainerId: '',
  iconClassName: '',
  imageClassName: '',
  videoClassName: '',
  theatreModeClassName: '',
  videoActive: false,
  isPrime: false,
  videoPlayCallback: () => {},
  //VideoComponentLoadOrUnloadListener: undefined,
  isWapView: false,
  onVideoComplete: undefined,
  dockCandidate: undefined,
  unDockCandidate: undefined,
  addDockCandidate: undefined,
  addUnDockCandidate: undefined,
  deleteDockCandidate: undefined,
  deleteUnDockCandidate: undefined,
  isLeadVideo: false,
  isUserPrime: false,
  videoTheatreSliderData: false,
  addNextVideoMsid: undefined,
  //enableNextVideos: false,
  dataFirstPlayClickGa: '',
  dataCloseClickGa: '',
  isArticleshow: false,
  dataSetGaCategory: false,
  isVideoSkipAds: false,
  isInline: false,
  loadedMiniTvComponent: false,
  posKey: '',
  lazyLoadYoutubeVid: false,
  isMute: false,
  enableDocking: false,
  leadVideoIsDockedCallback: () => {},
};

VideoWidget.contextTypes = {
  store: PropTypes.object.isRequired,
};

const mapDispatchToProps = dispatch => ({
  addDockCandidate: data => {
    dispatch(addDockCandidate(data));
  },
  addUnDockCandidate: data => {
    dispatch(addUnDockCandidate(data));
  },
  deleteDockCandidate: () => {
    dispatch(deleteDockCandidate());
  },
  deleteUnDockCandidate: () => {
    dispatch(deleteUnDockCandidate());
  },
});

const mapStateToProps = state => ({
  dockCandidate:
    typeof state.articleshow_v2 !== 'undefined'
      ? state.articleshow_v2.dockCandidate
      : undefined,
  unDockCandidate:
    typeof state.articleshow_v2 !== 'undefined'
      ? state.articleshow_v2.unDockCandidate
      : undefined,
  loadedMiniTvComponent: true, //state.miniTv?.data?.status === '1', temporarily commented for LBand ads campaign
});

export default connect(mapStateToProps, mapDispatchToProps)(VideoWidget);
